import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getTransferItemsView from 'checkout/selectors/view/itemViews/getTransferItemsView'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'
import { generateLoyaltyPointsCalculatorTransfersOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'

const getCheckoutTransfersPointsCalculationRequest = createSelector(
  (state: App.State) => getTransferItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (transferViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!transferViews.hasRequiredData) return EmptyArray

    return transferViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => {
      const itemId = itemView.item.itemId
      const request = generateLoyaltyPointsCalculatorTransfersOptions({
        price: itemView.totals.price,
        memberPrice: itemView.totals.memberPrice,
        offerId: itemView.item.experienceId,
        promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId } }),
      })!

      const checkoutRequest = {
        ...request,
        // Local checkout correlation only; omitted from the API payload and points key.
        itemId,
      }

      return checkoutRequest
    })
  },
)

export default getCheckoutTransfersPointsCalculationRequest
